import { Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardAlarmsRequest } from '../../model/DashboardAlarmsRequest';
import { DashboardAlarmsDTO } from '../../model/DashboardAlarmsDTO';
import { EnumAlarmCategoriesValues } from 'src/app/features/shared/helpers/enums/EnumAlarmCategories';
import { BaseChartDirective } from 'ng2-charts';
import { environment } from "src/environments/environment";
@Component({
  selector: "alarm-chart",
  templateUrl: "./alarm-chart.component.html",
  styleUrls: ["./alarm-chart.component.css"],
})
export class AlarmChartComponent {
  @ViewChild(BaseChartDirective) chart?: BaseChartDirective;

  @Input() dashboardAlarms: DashboardAlarmsRequest[] = [];
  @Input() currentMonth = "";

  isLoading: boolean = false;
  today = new Date();
  @Input() selectedDate = this.today;
  
  showCalendar = false;
  calendarDays: (number | null)[] = [];
  
  chartColors: any[] = [
    {backgroundColor: 'rgba(0, 71, 171, 0.6)', borderColor: 'rgba(0, 71, 171, 1)'},
    {backgroundColor: 'rgba(0, 111, 221, 0.6)', borderColor: 'rgba(0, 111, 221, 1)'},
    {backgroundColor: 'rgba(0, 150, 255, 0.6)', borderColor: 'rgba(0, 150, 255, 1)'},
    {backgroundColor: 'rgba(51, 170, 255, 0.6)', borderColor: 'rgba(51, 170, 255, 1)'},
    {backgroundColor: 'rgba(102, 190, 255, 0.6)', borderColor: 'rgba(102, 190, 255, 1)'},
    {backgroundColor: 'rgba(153, 210, 255, 0.6)', borderColor: 'rgba(153, 210, 255, 1)'},
    {backgroundColor: 'rgba(204, 230, 255, 0.6)', borderColor: 'rgba(204, 230, 255, 1)'},
  ];
  chartData = {
    labels: [],
    datasets: [],
  };

  chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display:false,
        position: 'top',
      },
      tooltip: {
        mode: 'index',
        callbacks: {
          labelColor: (context: any) => {
            const idx = context.datasetIndex ?? 0;
            const color = this.chartColors[idx] ?? { backgroundColor: 'rgba(0,0,0,0.1)', borderColor: 'rgba(0,0,0,0.1)' };
            return {
              borderColor: color.borderColor,
              backgroundColor: color.backgroundColor
            };
          }
        }
      },
      datalabels: {
        display: false
      }
    },
    interaction: {
      mode: 'nearest',
      axis: 'x',
      intersect: false
    },
    scales: {
      x: {
        stacked: false,
        title: {
          display: true,
          text: 'día del mes'
        }
      },
      y: {
        stacked: false,
        title: {
          display: true,
          text: 'Alertas'
        }
      },
    },
  };

  constructor(private router: Router
  ) {}

  ngOnInit() {
    this.isLoading = true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("changes,", changes);
    
    var shouldUpdateChart = false;

    if (changes['dashboardAlarms'] && this.dashboardAlarms ) {
      shouldUpdateChart = true;
    }

    if (changes['selectedDate'] && this.selectedDate) {
      // shouldUpdateChart = true;
      this.isLoading = true;
    }

    if (shouldUpdateChart) {
      this.isLoading = true;
      this.updateChart();
      this.isLoading = false;
    }
  }

  private updateChart(): void {
    try{
      this.chartData.labels = [];
      this.chartData.datasets = [];
      this.chartData.labels = this.getLabelsActual();
      this.chartData.datasets = this.getDataSets(this.dashboardAlarms);
      this.chart?.update();
    } catch (error) {
      this.chartData.labels = [];
      this.chartData.datasets = [];
      this.chart?.update();
      this.isLoading = false;
      console.error('Error actualizando el chart:', error);
    }
  }
  
  onChartClick(event: { event?: MouseEvent, active?: any[] }) {
    if (event.active && event.active.length > 0) {
      const chartElement = event.active[0] as any;
      const dataSetIndex = chartElement.datasetIndex;
      //el index de la data va a ser el día del mes
      const dataIndex = chartElement.index;

      const data = this.chartData.datasets[dataSetIndex];
      if (data) {
        const alarmName = data.label;
        const alarmDay= dataIndex + 1;
      if(!environment.production) console.log(alarmName, alarmDay, data, chartElement);
      }
    }
  }
 
  openAlarmsTable(){
    this.router.navigate(['/alarms'], { queryParams: {  } });
  }

  getLabels(): string[] {
    const year = this.selectedDate.getFullYear();
    const month = this.selectedDate.getMonth();
    const days = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30"];
    var labels = [];
    days.forEach(day => {
      const label = day + "/" + (month + 1).toString().padStart(2, '0') + "/" + year;
      labels.push(label);
    });
    if(!environment.production) console.log("labels 1",labels);
    return labels;
  }

  //este están como llegan ahorita
  getLabelsActual(): string[] {
    const year = this.selectedDate.getFullYear();
    const month = this.selectedDate.getMonth();
    const days = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30"];
    var labels = [];
    days.forEach(day => {
      const label =  day  + "/" + (month + 1).toString().padStart(2, '0') + "/" + year;
      labels.push(label);
    });
    if(!environment.production) console.log("labels 2",labels);
    return labels;
  }

  getDataSets(alarms: DashboardAlarmsRequest[]){
    //traigo las de este mes y año
    var thisMonthAlarms : DashboardAlarmsRequest[] = [];
    const month = this.selectedDate.getMonth();
    const year = this.selectedDate.getFullYear();
    alarms.forEach(alarm => {
      //como viene ahorita en el date tipo usa mm/dd/yyyy hh:mm:ss
      // const alarmMonth = alarm.date.split("/")[0];
      // const alarmYear = alarm.date.split("/")[2].split(" ")[0];

      //si cambia a mexico dd/mm/yyyy hh:mm:ss, seria este
      const alarmMonth = alarm.date.split("/")[1];
      const alarmYear = alarm.date.split("/")[2];

      if(alarmMonth == (month + 1).toString().padStart(2, '0') && alarmYear == year.toString()){
        thisMonthAlarms.push(alarm);
      }

    });
    if(!environment.production) console.log("thisMonthAlarms", thisMonthAlarms);
    
    //un map para las fechas de los labels y poder agregarles los días que no tienen datos
    const baseMap = new Map<string, number>();
    this.chartData.labels.forEach(label => {
      baseMap.set(label, 0);
    });

    var alarmData: DashboardAlarmsDTO[] = [];
    thisMonthAlarms.forEach(alarm => {
      const label = alarm.date;
      const existingAlarm = alarmData.find(alarmD => alarmD.categoryName === alarm.categoryName);
      baseMap.set(alarm.date, alarm.quantityPerDay);

      if (existingAlarm) {
        existingAlarm.quantityPerDay.set(label, existingAlarm.quantityPerDay.get(label) + alarm.quantityPerDay);
      } else {
        const copiaMap = new Map(baseMap);
        copiaMap.set(label, alarm.quantityPerDay);
        alarmData.push({
          categoryName: alarm.categoryName,
          quantityPerDay: copiaMap,
          date: alarm.date
        });
      }
    });
    if(!environment.production) console.log("alarmData", alarmData);

    var datasets = alarmData.map((alarm, index) => ({
          label: EnumAlarmCategoriesValues[alarm.categoryName] || alarm.categoryName,
          data: Array.from(alarm.quantityPerDay.values()),
          backgroundColor: this.chartColors[index].backgroundColor,
          borderColor: this.chartColors[index].borderColor,
          borderWidth: 2,
          fill: true,
          tension: 0.4,
          pointRadius: 4,
          pointHoverRadius: 6,
          pointBackgroundColor: this.chartColors[index].borderColor,
          pointBorderColor: '#fff',
          pointBorderWidth: 1,
          disabled: false,
          parsed: true, 
        }));

    return datasets;
  }

  toggleCalendar(): void {
    this.showCalendar = !this.showCalendar;
    if (this.showCalendar) {
      this.generateCalendarDays();
    }
  }

  generateCalendarDays(): void {
    const year = this.selectedDate.getFullYear();
    const month = this.selectedDate.getMonth();
    
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    
    const firstDayOfWeek = firstDay.getDay();
    const daysInMonth = lastDay.getDate();
    
    this.calendarDays = [];
    
    for (let i = 0; i < firstDayOfWeek; i++) {
      this.calendarDays.push(null);
    }
    
    for (let day = 1; day <= daysInMonth; day++) {
      this.calendarDays.push(day);
    }
  }

  getCalendarMonth(): string {
    return this.selectedDate.toLocaleDateString('es-ES', { month: 'long', year: 'numeric' });
  }

  isToday(day: number | null): boolean {
    if (!day) return false;
    const today = new Date();
    return day === today.getDate() && 
           this.selectedDate.getMonth() === today.getMonth() && 
           this.selectedDate.getFullYear() === today.getFullYear();
  }

}
